export { DetailModel } from './Detail';
export { BankModel } from './Bank.model';
export { MainModel } from './Main.model';
